/**
 * Countdown timer for .saleBanner elements.
 *
 * By default, each .saleBanner looks up the nearest ancestor with
 * data-timer-dates (e.g. the top bar wrapper, populated from the theme
 * setting "Sale countdown timer" -> "Countdown reset dates") and counts
 * down to the earliest listed date/time that's still in the future. Once
 * that date passes, the next visit picks up the following date in the
 * list automatically — no manual edits needed as long as the settings
 * list stays topped up.
 *
 * A .saleBanner can still opt out of that and set its own fixed deadline
 * via data-expiry (ISO datetime, local to data-timezone) / data-timezone
 * ("+HHMM" offset) directly on the element.
 *
 * Example markup:
 *   <div class="saleBanner">
 *     Offer ends in <span class="countdown">Loading...</span>
 *   </div>
 */
(function () {
  function normalizeTz(raw) {
    // Convert "+0100" → "+01:00" for ISO 8601 compatibility
    return (raw || '+0000').trim().replace(/^([+-])(\d{2})(\d{2})$/, '$1$2:$3');
  }

  function resolveExpiry(banner) {
    var container = banner.closest('[data-timer-dates]');
    var datesAttr = container ? container.dataset.timerDates : '';

    if (datesAttr && datesAttr.trim()) {
      var tz = normalizeTz(container.dataset.timerTimezone);
      var now = Date.now();

      var dates = datesAttr
        .split(',')
        .map(function (s) { return new Date(s.trim() + tz); })
        .filter(function (d) { return !isNaN(d.getTime()); })
        .sort(function (a, b) { return a - b; });

      if (dates.length) {
        var next = dates.find(function (d) { return d.getTime() > now; });
        return next || dates[dates.length - 1];
      }
    }

    // Fallback: fixed deadline set directly on the banner
    if (banner.dataset.expiry) {
      return new Date(banner.dataset.expiry + normalizeTz(banner.dataset.timezone));
    }

    return null;
  }

  function initCountdowns(root) {
    var banners = (root || document).querySelectorAll('.saleBanner');

    banners.forEach(function (banner) {
      // Prevent double-init on theme-editor re-renders
      if (banner.dataset.mhCountdownInit) return;
      banner.dataset.mhCountdownInit = '1';

      var countdownEl = banner.querySelector('.countdown');
      if (!countdownEl) return;

      var expiry = resolveExpiry(banner);

      if (!expiry || isNaN(expiry.getTime())) {
        countdownEl.textContent = '';
        return;
      }

      function pad(n) {
        return String(n).padStart(2, '0');
      }

      // "00<i>d</i>" — the unit letter is a hook for smaller styling
      function seg(value, unit) {
        return pad(value) + '<i>' + unit + '</i>';
      }

      function tick() {
        var diff = expiry.getTime() - Date.now();

        if (diff <= 0) {
          countdownEl.textContent = 'Expired';
          clearInterval(interval);
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days    = Math.floor(totalSeconds / 86400);
        var hours   = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        var parts = [];
        if (days > 0) parts.push(seg(days, 'd'));
        parts.push(seg(hours, 'h'));
        parts.push(seg(minutes, 'm'));
        parts.push(seg(seconds, 's'));

        countdownEl.innerHTML = parts.join(' : ');
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  }

  // Initial boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCountdowns(); });
  } else {
    initCountdowns();
  }

  // Shopify theme editor re-init
  document.addEventListener('shopify:section:load', function (e) { initCountdowns(e.target); });
  document.addEventListener('shopify:block:load',   function (e) { initCountdowns(e.target); });
})();
